








import { Vue, Component } from 'vue-property-decorator';
import { Page } from '@/components/Page.vue';

@Component({
  name: 'Customers',
  components: {
    Page,
  },
})
export default class Customers extends Vue {
}
